import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import smsService from "../../../api/reservePlanNew.service";
import telematicsService from "../../../api/telematics.service";
import rules from "../../../utils/rules";
import moment from "moment";
import schedulerDialog from "@/components/SchedulerDialog";

export default {
  name: "actual-cost-to-date-report",
  components: { pageheader, schedulerDialog },
  data() {
    return {
      ScheduleReportName: "ACTUALCOSTTODATE",
      input: {},
      reportsList: [],
      loadergetcalls: false,
      selected: [
        "Dates",
        "Equipment",
        "Geofence",
        "Group",
        "Jobsite",
        "Model",
        "Search Field",
      ],
      selectedMachine: [],
      menufilter: false,
      filterTypes: [
        { id: "1", name: "Dates" },
        { id: "2", name: "Equipment" },
        { id: "3", name: "Geofence" },
        { id: "4", name: "Group" },
        { id: "5", name: "Jobsite" },
        { id: "6", name: "Model" },
        { id: "7", name: "Search Field" },
      ],
      isReportLoading: false,
      loadingMachines: false,
      machineSearchFilter: null,
      machines: [],
      zoneSearchFilter: "",
      groupSearchFilter: "",
      groups: [],
      selectedGroup: [],
      jobSiteSearchFilter: "",
      locations: [],
      jobSiteList: [],
      loadinglocations: false,
      selectedJobSite: [],
      selectedJobSiteNames: [],
      selectedZone: [],
      zonesList: [],
      modelSearchFilter: "",
      models: [],
      selectedModel: [],
      searchMenu: false,
      searchEquipName: "",
      searchPO: "",
      searchJob: "",
      searchContractId: "",
      nodataMachine: false,
      showmachinmsg: true,
      fromDate: "",
      toDate: new Date().toISOString().slice(0, 10),
      dateCheck: false,
      dateErrorMsg: "",
      dateMax: false,
      dateErrorMsgmax: "",
      search: "",
      menu1: false,
      menu2: false,
      isReportExporting: false,
      isDownloading: false,
      showTable: false,
      header: [
        { text: "Access Control Code", value: "accessControlCode", sortable: true, width: "160px" },
        { text: "Equipment #", value: "itemKey", width: "150px" },
        { text: "Equipment", value: "itemName", width: "200px" },
        { text: "Telematics SN", value: "telematicsDeviceSN" },
        { text: "Customer Name", value: "customerName" },
        { text: "Contract #", value: "cntr" },
        { text: "Department", value: "department", width: "150px" },
        { text: "Qty", value: "qty", width: "80px" },
        { text: "Cost", value: "cost" },
        { text: "Date Out", value: "dateOut" },
        { text: "Date Due", value: "dateDue" },
        { text: "Date Billed", value: "dateBilled" },
        { text: "Days On Rent", value: "daysOnRent" },
        { text: "Jobsite", value: "jobsite" },
        { text: "Job #", value: "jobNo" },
        { text: "PO #", value: "poNo", width: "100px" },
        { text: "Ordered By", value: "orderedBy" },
        { text: "Picked Up By", value: "pickedupBy" },
        { text: "Transaction Status", value: "transactionType" },
        { text: "Department", value: "department", width: "150px" },
        { text: "Last GPS Address", value: "lastGPSAddress", width: "200px" },
      ],
      rules: rules,

      smsCustomersList: [],
      selectedSMSCustomer: "",
      isCustLoad: false,
      isDownloadCSV: false,
      csvName: "Actual Spend to Date.xlsx",
      pdfName: "Actual Spend to Date.pdf",

      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,

      selectedDays: [],
      custnum: "",
      custid: "",

      errorMSG: "Please select customer to run the report",
      selectedExportOption: null,
      exportOptions: ["Excel", "PDF"],
      closeOnContentClick: false,
    };
  },
  watch: {
    machineSearchFilter(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsCNum",
      "smsCustomerId",
      "smsUserId",
      "smsCustomerLinkingId",
      "companyNameDropdown",
      "companyIdDropdown",
    ]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    formatTimeStamp: function (val) {
      return moment.utc(val * 1000).format("HH:mm:ss");
    },
  },
  async mounted() {
    this.input = utils.getInputContent("actualSpendToDateReport", this.roles);
    this.loadergetcalls = false;
    await this.getGroups();
    await this.getJobSites();
    await this.getLocations();

    await this.getModels();
    await this.getZones();
    this.loadergetcalls = true;
  },
  methods: {
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    mindate() {
      return moment().subtract(3, "years").format("YYYY-MM-DD");
    },
    maxdate() {
      return new Date().toISOString().slice(0, 10);
    },
    datesCompare() {
      if (this.fromDate && this.toDate) {
        let dateCheck =
          moment(this.toDate).format("YYYY-MM-DD") >=
          moment(this.fromDate).format("YYYY-MM-DD");
        this.dateCheck = dateCheck;
        if (!this.dateCheck) {
          this.dateErrorMsg = "To Date should be greater than From Date";
        }
        let maxmonths = moment(this.toDate).diff(
          moment(this.fromDate),
          "months",
          true
        );

        this.dateMax = maxmonths <= 12;
        if (!this.dateMax) {
          this.dateErrorMsgmax = "Only 1 year date range is allowed";
        }
      }
    },
    async getReportList() {
      this.isReportLoading = true;
      try {
        let response = await smsService.getActualCostReport(
          this.fromDate,
          this.toDate,
          this.selectedMachine,
          this.selectedZone,
          this.selectedGroup,
          this.selectedJobSiteNames,
          this.selectedModel,
          this.searchEquipName,
          this.searchPO,
          this.searchJob,
          this.searchContractId
        );
        if (response.isSuccess && response.data.length > 0) {
          this.showTable = true;
          this.reportsList = response.data;
          this.isReportLoading = false;
        } else {
          this.reportsList = [];
          this.isReportLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
      }
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = new Date().toISOString().slice(0, 10);
      this.reportsList = [];
      this.selectedGroup = [];
      this.selectedMachine = [];
      this.selectedModel = [];
      this.selectedZone = [];
      this.selectedJobSite = [];
      this.selectedJobSiteNames = [];
      this.searchEquipName = "";
      this.searchPO = "";
      this.searchJob = "";
      this.searchContractId = "";
      this.getReportList();
    },

    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },

    async searchMachines(value) {
      let machineValue = "";
      machineValue = encodeURIComponent(value);
      this.machines = [];
      try {
        this.loading = true;
        let response = await telematicsService.getTelematicMachinesnew(
          machineValue
        );
        if (response && response.data.length != 0) {
          this.machines = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              tuUnitId: item.tuUnitId ? item.tuUnitId : "",
              machine: String(index),
              stockKey: item.stockKey ? item.stockKey : "",
            };
          });
          this.loading = false;
        } else {
          this.nodataMachine = true;
          this.showmachinmsg = false;
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        this.nodataMachine = true;
        this.showmachinmsg = false;
        console.log(err);
      }
    },
    async getZones() {
      try {
        let response = await telematicsService.getZones();
        if (response && response.data) {
          this.zonesList = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              Zone: String(index),
            };
          });
        } else {
          this.zonesList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      try {
        this.loading = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",

              group: String(index),
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.locations = response.data.filter((e) => e.locationName != null);
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },
    async getModels() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              model: String(index),
            };
          });

          this.loadingmodel = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getJobSites() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = response.data.filter(
            (e) => e.locationName != null
          );
        } else {
          this.jobSiteList = [];
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    clearDates() {
      if (this.fromDate) {
        this.fromDate = "";
      }
      if (this.toDate) {
        this.toDate = "";
      }
      this.dateErrorMsg = "";
      this.dateErrorMsgmax = "";
    },
    resetGroup() {
      (this.selectedGroup = []), (this.reportsList = []);
    },
    resetMachine() {
      (this.selectedMachine = []), (this.reportsList = []);
    },
    resetZone() {
      this.selectedZone = [];
    },
    resetJobSite() {
      this.selectedJobSite = [];
      this.jobSiteChange();
    },
    resetModel() {
      this.selectedModel = [];
    },
    clearSearchEquipName() {
      this.searchEquipName = "";
    },
    clearSearch() {
      this.searchPO = "";
    },
    clearSearchJob() {
      this.searchJob = "";
    },
    clearSearchContractId() {
      this.searchContractId = "";
    },
    zoneChange() {
      this.selectedZonesNames = [];
      this.selectedZonesNames = this.selectedZone.map(
        (id) => this.zonesList.find((el) => el.id == id).name
      );
    },
    modelChange() {
      this.selectedModelNames = [];
      this.selectedModelNames = this.selectedModel.map(
        (id) => this.models.find((el) => el.id == id).name
      );
    },
    jobSiteChange() {
      this.selectedJobSiteNames = [];
      this.selectedJobSiteNames = this.selectedJobSite.map(
        (locationId) =>
          this.locations.find((el) => el.locationId == locationId).locationName
      );
    },
    async downloadReport(exportOption) {
      try {
        let response = await smsService.exportActualCostReport(
          exportOption,
          this.fromDate,
          this.toDate,
          this.selectedMachine,
          this.selectedZone,
          this.selectedGroup,
          this.selectedJobSiteNames,
          this.selectedModel,
          this.searchEquipName,
          this.searchPO,
          this.searchJob,
          this.searchContractId
        );
        if (response) {
          if (exportOption == this.exportOptions[0]) {
            //excel
            utils.downloadExcelFile(response, this.csvName);
          } else {
            //pdf
            utils.downloadPDFFile(response, this.pdfName);
          }
        } else {
          this.$toast.error(
            "Unable to download the report. Please contact admin."
          );
        }
        this.isDownloading = false;
      } catch (error) {
        this.$toast.error(
          "Unable to download the report. Please contact admin."
        );
        this.isDownloading = false;
      }
    },
    exportIconClick(item) {
      this.selectedExportOption = item;
      if (this.selectedExportOption) {
        this.isDownloading = true;
        //case  "excel"
        if (this.selectedExportOption == this.exportOptions[0]) {
          this.downloadReport(this.exportOptions[0]);
        } else if (this.selectedExportOption == this.exportOptions[1]) {
          //case  "Pdf"
          this.downloadReport(this.exportOptions[1]);
        }
      }
    },
    openScheduledDialog() {
      this.$refs.modal.showScheduleModal();
    },
  },
};
